// extracted by mini-css-extract-plugin
export default {"input":"S7-z","button":"T7-z","selected":"U7-z","unavailable":"V7-z","oos":"W7-z","image":"X7-z","paperCutDisabledOverlay":"Y7-z"};